<template>
    <div class="container" v-if="show">
            <table id="myRepPatTestROTable" class="table table-dark table-hover table-sm" style="width: 100%;">
                <thead class="">
                <tr>
                    <th>RO No.</th>
                    <th>วันที่</th>
                </tr>
                </thead>
                <tbody>
                    <tr v-for="item in datalists3" :key="item.ROID">
                        <td class="">{{ item.RONo }}</td>
                        <td class="text-start">{{ item.DocDate }}</td>
                    </tr>
                </tbody>
            </table>
    </div>
</template>

<script>
// import axios from 'axios'
import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// Datatable Modules
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
// import $ from 'jquery'
import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

// import RepPatSummary2PatTestList from './RepPatSummary2PatTestList.vue'

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition
    }
  },
  masks: {
    input: 'YYYY-MM-DD'
  },
  name: 'RepPatSummary2',
  components: {
    // RepPatSummary2PatTestList
  },
  data () {
    return {
      arrRepeatChk: ['', 'R'],
      arrSex: ['', 'Male', 'Female'],
      arrDocStatus: ['New', 'Lab', 'Resulted', 'AP'],
      arrPayType: ['เงินสด', 'เครดิต'],

      datalists3: []
    }
  },
  // เงื่อนไขสำหรับดึงข้อมูลหน้าหลัก
  props: ['show', 'branchID', 'dateFm', 'dateTo', 'patID', 'testID'],
  created () {
    // Initial Value
  },
  mounted () {
    this.getData3()
  },
  methods: {
    getData3 () {
      var docDateFm = this.dateFm.toISOString().slice(0, 10)
      var docDateTo = this.dateTo.toISOString().slice(0, 10)
      var BranchID = this.branchID
      var PatID = this.patID
      var TestID = this.testID
      // console.log('PatID : ')
      // console.log(this.patID)
      MyApiClient.get('getdata/reppatsummary3pattestrolist_where.php?C1=' + this.globalCorpID + '&BranchID=' + BranchID +
        '&DocDateFm=' + docDateFm + '&DocDateTo=' + docDateTo + '&PatID=' + PatID + '&TestID=' + TestID)
        .then((resp) => {
        //   console.log(resp.data.response)
          var rows = Object.assign({}, resp.data.response)
          this.datalists3 = rows
          // this.datalists3 = resp.data.response
          if (this.datalists3 == null) {
            Swal.fire({ icon: 'info', text: 'ไม่มีข้อมูล', showConfirmButton: false, timer: 1000 })
          }
          this.$nextTick(() => {
            // this.countRefresh1++
            // $('#myRepPatSummaryTable2').DataTable()
          })
          // setTimeout(function () { $('#myRepLabStatusTable').DataTable() }, 0)
          this.countRefresh++
        })
        .catch((err) => {
          console.log(err.response)
        })
    }
  }
}
</script>

<style>

</style>
